export enum ValidateEmailResponseCode {
  EMPTY = 'EMPTY',
  VALID = 'VALID',
  INVALID = 'INVALID',
  EXISTING = 'EXISTING',
  ERROR = 'ERROR'
}

export interface ValidateEmailResponse {
  status: boolean;
  code: ValidateEmailResponseCode;
  error: string;
}
